import { render, staticRenderFns } from "./Agreement.vue?vue&type=template&id=5fc21dbf&scoped=true&"
import script from "./Agreement.vue?vue&type=script&lang=js&"
export * from "./Agreement.vue?vue&type=script&lang=js&"
import style0 from "./Agreement.vue?vue&type=style&index=0&id=5fc21dbf&prod&lang=less&"
import style1 from "./Agreement.vue?vue&type=style&index=1&id=5fc21dbf&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fc21dbf",
  null
  
)

export default component.exports